import React from 'react';

import './autosuggest-basic.scss';

const AutosuggestBasic: React.FC = () => (
    <div className="react-autosuggest__container">
        <input
            aria-label="Znajdź produkt..."
            type="text"
            autoComplete="off"
            className="react-autosuggest__input"
            name="query"
            placeholder="Znajdź produkt..."
        />
        <div className="react-autosuggest__suggestions-container">
            {''}
        </div>
    </div>
);

export default AutosuggestBasic;
